import get from 'lodash.get';

const getPartnerLogo = (rootState) => get(rootState, 'partner.properties.wsBranding.companyLogo');

export default getPartnerLogo;
